import { ColorModePropKeys, ColorPrimitivesPropKeys, GradientPropKeys, ShadowPropKeys } from './colors';
import { SpacingAndSizePropKeys } from './spacing';
import { TypographyPropKeys } from './typography';
import { breakpoints, BreakpointKey } from './breakpoints';
import { FlattenSimpleInterpolation, css } from 'styled-components';

type CssPropKeys =
  | SpacingAndSizePropKeys
  | TypographyPropKeys
  | ColorModePropKeys
  | GradientPropKeys
  | ColorPrimitivesPropKeys
  | ShadowPropKeys;
type CssVariables = `var(--${CssPropKeys})`;

// Shorthand for css variables from prop values
export const cssVar = (key: CssPropKeys): CssVariables => `var(--${key})`;

// Helper to generate media queries for max-width breakpoints
export const mediaQuery = (
  breakpoint: BreakpointKey,
  content: FlattenSimpleInterpolation,
  widthBreakpointOrientation: 'max' | 'min' = 'max'
): FlattenSimpleInterpolation => {
  return css`
    @media (${widthBreakpointOrientation}-width: ${breakpoints[breakpoint]}) {
      ${content}
    }
  `;
};

// Helper to generate media queries for height breakpoints
export const mediaQueryHeight = (
  breakpoint: BreakpointKey,
  content: FlattenSimpleInterpolation,
  widthBreakpointOrientation: 'max' | 'min' = 'max'
): FlattenSimpleInterpolation => {
  return css`
    @media (${widthBreakpointOrientation}-height: ${breakpoints[breakpoint]}) {
      ${content}
    }
  `;
};

// Helper to convert component props to styled props by prefixing with $
export const componentPropsToStyledProps = (props: unknown): Record<string, unknown> => {
  return Object.fromEntries(Object.entries(props).map(([key, value]) => [`$${key}`, value]));
};
